import {Aina} from "../domain/resources/aina/Aina";

/** Include the selected place and all descendants; GUIDs avoid ambiguous place labels. */
export function buildAinaDescendantIndex(places:Array<Pick<Aina, "guid" | "children">>):Map<string, string[]> {
	const byGuid = new Map(places.map(place => [place.guid, place] as [string, Pick<Aina, "guid" | "children">]));
	const index = new Map<string, string[]>();
	for (const place of places) {
		const included = new Set<string>();
		const pending = [place.guid];
		while (pending.length) {
			const guid = pending.pop();
			if (!guid || included.has(guid)) { continue; }
			included.add(guid);
			const current = byGuid.get(guid);
			for (const child of current?.children || []) {
				if (child?.guid) { pending.push(child.guid); }
			}
		}
		index.set(place.guid, Array.from(included));
	}
	return index;
}
